<template>
    <div id = "main">
        <!-- eslint-disable max-len -->
        <div v-for="(item, index) in jsonData" :key="index" class="article">

          <h2>
            {{ $translation.L(item.title) }}
          </h2>
          <h3> {{ item.date !== null ? item.date : "" }} </h3>
          <b-img v-if="item.photo !== 'none'" :src='`images/${item.photo}`'></b-img>
          <p v-for="(text, i) in item.paragraphs" :key="i">
            {{ $translation.L(text) }}
          </p>
        </div>
    </div>
</template>

<script>
export default {
  name: 'mainMenu',
  data() {
    return {
      jsonData: this.$config.hallOfFame,
    };
  },
  methods: {
    resolveImgUrl(path) {
      const images = require.context('../../public/images/', false, /\.png$|\.jpg$/);
      try {
        return images(`./${path}`);
      } catch {
        return images('./blank-man.jpg');
      }
    },
  },
};
</script>

<style scoped>
    * {
        user-select: none;
    }

    #main {
        display: inline-block;
        box-sizing: border-box;
        width:100%;
        height: 80%;
        background-color: white;
        padding: 5vw;
        font-size: 3.5vw;
    }

    .article {
      display: block;
      border-radius: 2px;
      box-sizing: border-box;
      margin-bottom: 2vw;
      border-bottom: 1px solid #eee;
      padding-bottom: 3vw;
    }

    img {
      max-width: 80%;
    }

    h2 {
      margin: 4vw;
    }

    p {
      margin: 2vw;
    }

    p, h2 {
      color: #333;
    }

    h3 {
      color: #888;
      font-size: 2.5vw;
      display:block;
    }

    @media only screen and (min-width: 1024px) {
      .article {
        display: inline-block;
      }
      h2 {
        margin: 1vw;
      }
      p {
        margin: 0.7vw;
        text-align: left;
      }
      #main {
        font-size: 1.2vw;
      }

      img {
        max-width: 40%;
        float: left;
        margin-right: 2vw;
      }

      h3 {
        font-size: 0.8vw;
      }
    }
</style>
